import React, {Suspense, useEffect} from 'react'
import dayjs from 'dayjs'
import {Redirect, Route, Switch, useHistory, useLocation} from 'react-router-dom'
import {FallbackView} from '../../_metronic/partials'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {DashboardCoreWrapper} from '../pages/dashboardCore/DashboardCoreWrapper'
import {BiographyWrapper} from '../pages/biography/BiographyWrapper'
import {MyExpertisePage} from '../pages/myExpertise/MyExpertisePage'
import {PaymentExpertWrapper} from '../pages/paymentExpert/PaymentExpertWrapper'
import {CalendarWrapper} from '../pages/calendar/CalendarWrapper'
import {ProfileAdminWrapper} from '../pages/profileAdmin/ProfileAdminWrapper'
import {BiographyFormWrapper} from '../pages/biography/BiographyFormWrapper'
import {PaymentExpertMessageWrapper} from '../pages/paymentExpert/PaymentExpertMessageWrapper'
import {ExpertiseWrapper} from '../pages/expertise/ExpertiseWrapper'
import {EditExpertisePage} from '../pages/expertise/EditExpertisePage'
import {RecognitionWrapper} from '../pages/recognition/RecognitionWrapper'
import {TeamWrapper} from '../pages/team/TeamWrapper'
import {ReferencesWrapper} from '../pages/references/ReferencesWrapper'
import {ExperiecesWrapper} from '../pages/experiences/ExperiencesWrapper'
import {shallowEqual, useSelector} from 'react-redux'
import {UserRole} from '../constants/roles'
import {RootState} from '../../setup'
import {SuggestExperienceWrapper} from '../pages/experiences/SuggestExperienceWrapper'
import SuggestionsAdminPage from '../pages/suggestions/SuggestionsAdminPage'
import {WaitingListWrapper} from '../pages/waitingList/WaitingListWrapper'
import {TermsPage} from '../pages/legal/TermsPage'
import {PrivacyPage} from '../pages/legal/PrivacyPage'
import MembershipPaymentWrapper from '../pages/memberships/MembershipPaymentWrapper'
import PaymentPage from '../pages/memberships/PaymentPage'
import ProfileBasePage from '../pages/profile/ProfilePage'
import {MembersWrapper} from '../pages/members/MembersWrapper'
import {MembersSearchWrapper} from '../pages/members/MembersSearchWrapper'
import {PlaceholderSearchWrapper} from '../pages/search/placeholder/PlaceholderSearchWrapper'
import {ExperiencesSearchWrapper} from '../pages/search/experiences/ExperiencesSearchWrapper'
import {ExpertsSearchWrapper} from '../pages/search/experts/ExpertsSearchWrapper'
import {ForumsSearchWrapper} from '../pages/search/forums/ForumsSearchWrapper'
import {SearchAllWrapper} from '../pages/search/all/SearchAllWrapper'
import {ExpertProfilePage} from '../pages/expertBooking/ExpertProfilePage'
import {BookExpertisePage} from '../pages/expertBooking/BookExpertisePage'
import {ExpertiseCheckoutPage} from '../pages/expertBooking/ExpertiseCheckoutPage'
import {ExpertisePaymentSuccessPage} from '../pages/expertBooking/ExpertisePaymentSuccessPage'
import {MemberDetailWrapper} from '../pages/members/MemberDetailWrapper'
import {ManageMemberWrapper} from '../pages/manageMembers/ManageMemberWrapper'
import {ProfileMemberWrapper} from '../pages/profileMembers/ProfileMemberWrapper'
import { AddExperiencePage } from '../pages/teamExperiences/AddExperiencePage'
import { AddExperienceSuccessPage } from '../pages/teamExperiences/SuccessAddExperiencePage'
import { HostExperiencePage } from '../pages/teamExperiences/HostExperiencePage'
import { AddExperienceDraftPage } from '../pages/teamExperiences/AddExperienceDraftPage'
import { AddExperiencePausedPage } from '../pages/teamExperiences/AddExperiencePausedPage'
import { EditExperiencePage } from '../pages/teamExperiences/EditExperiencePage'
import { ExperiencePreviewPage } from '../pages/experienceHostPreview/ExperiencePreviewPage'
import ExperienceAdminPage from '../pages/experiencesAdmin/ExperienceAdminPage'
import { HostPartnerExperiencePage } from '../pages/partnerExperiences/HostPartnerExperiencePage'
import { ExperiencesInProgressPage } from '../pages/partnerExperiences/ExperiencesInProgressPage'
import { TeamAdminPage } from '../pages/teamAdmin/TeamAdminPage'
import {ManageAdminWrapper} from '../pages/manageAdmins/ManageAdminWrapper'
import {PayoutsAdminWrapper} from '../pages/payoutsAdmin/PayoutsAdminWrapper'
import {CommissionsAdminWrapper} from '../pages/commissionsAdmin/CommissionsAdminWrapper'
import {AuditLogWrapper} from '../pages/auditLog/AuditLogWrapper'
import {ManagePartnerWrapper} from '../pages/managePartners/ManagePartnerWrapper'
import { MyExperiencesPage } from '../pages/userExperience/MyExperiencesPage'
import { AddPastExperiencePage } from '../pages/teamExperiences/AddPastExperiencePage'
import { MyTeamPage } from '../pages/myTeam/MyTeamPage'
import { AddMemberTeamPage } from '../pages/myTeam/AddMemberTeamPage'
import { EditMemberTeamPage } from '../pages/myTeam/EditMemberTeamPage'
import { ReferMemberPage } from '../pages/referMember/ReferMemberPage'
import { ExperienceBookingPage } from '../pages/experienceBooking/ExperienceBookingPage'
import { ComingSoonPage } from '../pages/comingSoon/ComingSoonPage'
import { ExperienceBookingSuccessPage } from '../pages/experienceBooking/ExperienceBookingSuccessPage'
import { FinancialPage } from '../pages/financial/FinancialPage'
import { ChangeMembershipPage } from '../pages/financial/ChangeMembershipPage'
import { PaymentsMethodPage } from '../pages/paymentMethod/PaymentMethodPage'
import { MembershipsFinancialPage } from '../pages/financial/MembershipsPage'
import { AuthPage } from '../modules/auth'
import AdminDashboardPage from '../pages/adminDashboard/AdminDashboardPage'
import { GuidePage } from '../pages/teamExperiences/GuidePage'
import CommunityListPage from '../pages/community/CommunityListPage'
import { CommunityDetailsPage } from '../pages/community/CommunityDetailsPage'
import CommunityFormPage from '../pages/community/CommunityFormPage'
import { CommunityFinishFormPage } from '../pages/community/CommunityFinishFormPage'
import { MastermindCirclesListPage } from '../pages/myMastermindCircles/MastermindCirclesListPage'
import { MastermindFormPage } from '../pages/myMastermindCircles/MastermindFormPage'
import { CommunityAdminListPage } from '../pages/communityAdmin/CommunityAdminListPage'
import { CommunityAdminReviewPage } from '../pages/communityAdmin/CommunityAdminReviewPage'
import { HelpCenterList } from '../pages/helpCenter/HelpCenterList'
import { HelpCenterDetails } from '../pages/helpCenter/HelpCenterDetails'
import RequestIntroductionPage from '../pages/introductions/RequestIntroductionPage'
import { RequestIntroductionSuccessPage } from '../pages/introductions/RequestIntroductionSuccessPage'
import IntroductionAdminListPage from '../pages/introductionAdmin/IntroductionAdminListPage'
import { CommunityAdminFormPage } from '../pages/communityAdmin/CommunityAdminFormPage'
import { IntroductionPage } from '../pages/introductions/IntroductionPage'
import CatalogAdminPage from '../pages/catalogAdmin/CatalogAdminPage'
import {PromoBannersAdminWrapper} from '../pages/promoBannersAdmin/PromoBannersAdminWrapper'
import MessagesPage from '../pages/messages/MessagesPage'
import NotificationsPage from '../pages/notifications/NotificationsPage'
import BookExpertPage from '../pages/bookExpert/BookExpertPage'
import ExpertDetailPage from '../pages/bookExpert/ExpertDetailPage'
import EngagementRequestPage from '../pages/bookExpert/EngagementRequestPage'
import MyEngagementsPage from '../pages/bookExpert/MyEngagementsPage'
import EngagementDetailPage from '../pages/bookExpert/EngagementDetailPage'
import PartnerExpertProfilePage from '../pages/partnerExpert/PartnerExpertProfilePage'
import PartnerExpertRegistrationPage from '../pages/partnerExpert/PartnerExpertRegistrationPage'
import { MyBookingsPage } from '../pages/myBookings/MyBookingsPage'

export function PrivateRoutes() {
  const user = useSelector((state: any) => state.auth?.user)
  const history = useHistory()
  const location = useLocation()
  const subscription = useSelector((state: RootState) => state.auth?.subscription, shallowEqual)

  useEffect(() => {
    if (!user) return

    // Only perform the role-based landing redirect when arriving at root or auth routes; otherwise deep-links
    // (typed URL, browser refresh, shared links) would always be stomped back to /main-dashboard.
    const isAuthRoute = location.pathname.startsWith('/auth')
    if (location.pathname !== '/' && !isAuthRoute) return

    const isSubscriptionValid =
      subscription?.status === 'active' ||
      subscription?.isActive === true ||
      Boolean((subscription as any)?.is_active) ||
      (Boolean(subscription?.currentPeriodEnd) && dayjs(subscription?.currentPeriodEnd).isAfter(dayjs())) ||
      (Boolean((subscription as any)?.current_period_end) && dayjs((subscription as any)?.current_period_end).isAfter(dayjs()))

    if(user?.roleRequiresSubscription && (!subscription || !isSubscriptionValid)){
      history.replace('/plans')
      return
    }

    if (user.role === UserRole.STAFF_USER || user.role === UserRole.ADMIN) {
      // Staff / Admin land on the admin dashboard (task hub) instead of the
      // waitlist -- the dashboard is the new central surface for admin work.
      history.replace('/dashboard/admin')
      return
    }

    if (user.role === UserRole.PROFILE_MANAGEMENT) {
      history.replace('/biography')
      return
    }
    
    if (user.role === UserRole.PARTNER) {
      const isExpertPartner = String(user.partnerType || '').toLowerCase().includes('expert')
      history.replace(isExpertPartner ? '/biography?option=bio' : '/my-experience')
      return
    }

    if (user.role === UserRole.FINAL_USER) {
      history.replace('/biography')
      return
    }

    if (user.role === UserRole.TEAM) {
      const modules = user.teamModules || []
      if (modules.includes('profile')) {
        history.replace('/biography?option=bio')
      } else if (modules.includes('experiences')) {
        history.replace('/user/my-experience')
      } else if (modules.includes('mastermind')) {
        history.replace('/my-mastermind-circles')
      } else {
        history.replace('/coming-soon')
      }
      return
    }
  }, [user, subscription, history, location.pathname])

  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        <Route path='/my-experience' component={AddExperiencePage} exact />
        <Route path='/host-experience' component={HostExperiencePage} />
        <Route path='/experience/detail/:id' component={ExperiencePreviewPage} />
        <Route path='/experience/edit/:id' component={EditExperiencePage} />
        <Route path='/experience/recreate/:id' component={AddPastExperiencePage} />
        <Route path='/experience/booking/:id' component={ExperienceBookingPage} exact />
        <Route path='/experience/booking/:id/success' component={ExperienceBookingSuccessPage} exact />
        <Route path='/experience/draft' component={ExperiencesInProgressPage} exact />
        <Route path='/experience/guide' component={GuidePage} exact />
        <Route path='/my-experience/success' component={AddExperienceSuccessPage} />
        <Route path='/my-experience/draft' component={AddExperienceDraftPage} exact/>
        <Route path='/my-experience/paused' component={AddExperiencePausedPage} exact/>
        <Route path='/experience/admin' component={ExperienceAdminPage} exact/>
        <Route path='/dashboard/admin' component={AdminDashboardPage} exact/>
        <Route path='/partner/my-experiences' component={HostPartnerExperiencePage} exact />
        <Route path='/user/my-experience' component={MyExperiencesPage} />
        <Route path='/book-expert' component={BookExpertPage} exact />
        <Route path='/book-expert/:id/request' component={EngagementRequestPage} exact />
        <Route path='/book-expert/:id' component={ExpertDetailPage} exact />
        <Route path='/engagements' component={MyEngagementsPage} exact />
        <Route path='/engagements/:id' component={EngagementDetailPage} exact />
        <Route path='/partner/expert/register' component={PartnerExpertRegistrationPage} exact />
        <Route path='/partner/expert' component={PartnerExpertProfilePage} exact />
        <Route path='/my-introduction' component={IntroductionPage} exact />
        <Route path='/introduction/request/:id' component={RequestIntroductionPage} exact />
        <Route path='/introduction/success' component={RequestIntroductionSuccessPage} exact />
        <Route path='/introductions' component={IntroductionAdminListPage} exact />
        <Route path='/user/refer' component={ReferMemberPage} exact />
        <Route path='/user/:userId/my-team' component={MyTeamPage} exact />
        <Route path='/user/:userId/my-team/add' component={AddMemberTeamPage} exact />
        <Route path='/user/:userId/my-team/edit/:id' component={EditMemberTeamPage} exact />
        <Route path='/user/payment/method' component={PaymentsMethodPage} />
        <Route path='/team/admin' component={TeamAdminPage} />
        <Route path='/plans' component={DashboardWrapper} />
        <Route path='/membership/payment' component={MembershipPaymentWrapper} />
        <Route path='/payment' component={PaymentPage} />
        <Route path='/dashboard' component={DashboardCoreWrapper} />
        <Route path='/biography/overview' component={BiographyFormWrapper} />
        <Route path='/biography' component={BiographyWrapper} />
        <Route path='/calendar' component={CalendarWrapper} />
        <Route path='/admin/overview/:section' component={ProfileAdminWrapper} />
        <Route path='/expert/success' component={PaymentExpertMessageWrapper} />
        <Route path='/expert' component={PaymentExpertWrapper} />
        <Route path='/expertise/payment-success' component={ExpertisePaymentSuccessPage} />
        <Route path='/expertise/checkout/:requestId' component={ExpertiseCheckoutPage} />
        <Route path='/expertise' component={ExpertiseWrapper} />
        <Route path='/recognition' component={RecognitionWrapper} />
        <Route path='/team' component={TeamWrapper} />
        <Route path='/references' component={ReferencesWrapper} />
        <Route path='/experiences/suggest' component={SuggestExperienceWrapper} />
        <Route path='/admin/suggestions' component={SuggestionsAdminPage} />
        <Route path='/experiences-search' component={ExperiencesSearchWrapper} />
        <Route path='/experiences' component={ExperiecesWrapper} />
        <Route path='/waitinglist' component={WaitingListWrapper} />
        <Route path='/terms-conditions' component={TermsPage} />
        <Route path='/privacy-policy' component={PrivacyPage} />
        {/* PR-I-85: pantalla member para publicar/editar su expertise. Debe ir
            antes que '/profile' (sin exact) para no ser tragada por ProfileBasePage. */}
        <Route path='/profile/edit-expertise' component={EditExpertisePage} exact />
        <Route path='/profile' component={ProfileBasePage} />
        <Route path='/main-dashboard' component={MembersWrapper} />
        <Route path='/members-search' component={MembersSearchWrapper} />
        <Route path='/forums-search' component={ForumsSearchWrapper} />
        <Route path='/circles-search' render={() => <PlaceholderSearchWrapper title='Mastermind Circles' />} />
        <Route path='/expert-search' component={ExpertsSearchWrapper} />
        <Route path='/search' component={SearchAllWrapper} />
        <Route path='/member/overview' component={MemberDetailWrapper} />
        <Route path='/experts/:partnerId/book' component={BookExpertisePage} />
        <Route path='/experts/:partnerId' component={ExpertProfilePage} />
        <Route path='/manage-members' component={ManageMemberWrapper} />
        <Route path='/profile-member' component={ProfileMemberWrapper} />
        <Route path='/manage-admins' component={ManageAdminWrapper} />
        <Route path='/manage-partners' component={ManagePartnerWrapper} />
        <Route path='/membership/change' component={ChangeMembershipPage} />
        <Route path='/financial' component={FinancialPage} exact />
        <Route path='/financial/membership/' component={MembershipsFinancialPage} exact />
        <Route path='/community' component={CommunityListPage} exact />
        <Route path='/community/details/:id' component={CommunityDetailsPage} />
        <Route path='/community/new' component={CommunityFormPage} />
        <Route path='/community/edit/:id' component={CommunityFormPage} />
        <Route path='/community/success' component={CommunityFinishFormPage} />
        <Route path='/my-expertise' component={MyExpertisePage} exact />
        <Route path='/my-bookings' component={MyBookingsPage} exact />
        <Route path='/my-mastermind-circles' component={MastermindCirclesListPage} exact/>
        <Route path='/my-mastermind-circles/new' component={MastermindFormPage} />
        <Route path='/my-mastermind-circles/edit/:id' component={MastermindFormPage} />
        <Route path='/messages' component={MessagesPage} exact/>
        <Route path='/notifications' component={NotificationsPage} exact/>
        <Route path='/admin/community' component={CommunityAdminListPage} exact/>
        <Route path='/admin/community/new' component={CommunityAdminFormPage} exact/>
        <Route path='/admin/community/review/:id' component={CommunityAdminReviewPage} />
        <Route path='/admin/catalog/:slug' component={CatalogAdminPage} exact />
        <Route path='/admin/catalog' component={CatalogAdminPage} exact />
        <Route path='/admin/banners' component={PromoBannersAdminWrapper} exact />
        <Route path='/admin/payouts' component={PayoutsAdminWrapper} exact />
        <Route path='/admin/commissions' component={CommissionsAdminWrapper} exact />
        <Route path='/admin/audit-log' component={AuditLogWrapper} exact />
        <Route path='/coming-soon' component={ComingSoonPage} />
        <Redirect from='/auth' to='/' />
        <Route path='/help-center' component={HelpCenterList} exact/>
        <Route path='/help-center/:id' component={HelpCenterDetails} exact/>
        <Redirect to='/error/404' />
      </Switch>
    </Suspense>
  )
}
